import React, { useEffect } from "react";

import { useTranslation } from "react-i18next";

import DesktopLayout from "@components-shared/desktop/layout/DesktopLayout";
import { setTabTitle } from "@utils";

export default function RestrictedPage() {
	const { t } = useTranslation();

	useEffect(() => {
		setTabTitle(t("RESTRICTION.RESTRICT_TITLE"));
		//on mount scroll to top
		document.querySelector("html, body")?.scrollTo(0, 0);
	}, []);

	return (
		<DesktopLayout>
			<section className="l--content l--content--full">
				<div className="l--content__main">
					<div className="container">
						<div className="card--primary card--shadowy card--message">
							<div className="card--message__thumb" />
							<div className="card--message__body">
								<div className="card--message__content">
									<i className="card--message__icon u-icon u-icon--xlrg u-icon--restricted u-icon--animated--bounce-in u-color--sent--danger" />
									<div>
										{t<string>(
											"RESTRICTION.COUNTRY_ACCESS_RESTRICTION_INFO",
											{
												0: t(
													"RESTRICTION.COMPANY_LABEL"
												),
											}
										)}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</DesktopLayout>
	);
}
